import _styled, { default as _styled2 } from "styled-components";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
type Option = {
  label: string;
  value: string;
};
type Props = {
  defaultValue?: string;
  label?: string;
  options: Option[];
  onChange?: (value: string) => void;
  value?: string;
};
const Item = /*#__PURE__*/_styled(RadixRadioGroup.Item).withConfig({
  componentId: "sc-sf-ox2wad-0"
})`
  &[type="button"] {
    ${{
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
}}
    ${{
  "height": "4rem",
  "whiteSpace": "nowrap",
  "borderRadius": "2px",
  "backgroundColor": "var(--bg-primary)",
  "paddingLeft": "var(--spacing-md)",
  "paddingRight": "var(--spacing-md)",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "outlineWidth": "0px",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
}}
    ${{
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(92 118 255 / var(--tw-bg-opacity))",
    "color": "var(--white-static)"
  }
}}
    ${{
  "&:focus-visible": {
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(75 46 248 / var(--tw-ring-opacity))",
    "--tw-ring-offset-width": "2px"
  }
}}

    &[data-state="checked"] {
      ${{
  "--tw-border-opacity": "1",
  "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))",
  "color": "var(--white-static)"
}}
    }
  }
`;
export function RadioGroup(props: Props) {
  const {
    label,
    options,
    onChange,
    value,
    ...rest
  } = props;
  return <_StyledRadixRadioGroupRoot onValueChange={val => onChange?.(val)} value={value} orientation="horizontal" aria-label={label} {...rest}>
      {options.map(({
      label,
      value
    }, idx) => <div key={idx}>
          <label>
            <Item value={value}>{label}</Item>
          </label>
        </div>)}
    </_StyledRadixRadioGroupRoot>;
}
var _StyledRadixRadioGroupRoot = /*#__PURE__*/_styled2(RadixRadioGroup.Root).withConfig({
  displayName: "radio-group___StyledRadixRadioGroupRoot",
  componentId: "sc-12fn2d3-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "var(--spacing-md)",
  "borderRadius": "4px"
});